import React from "react";
import { useTranslation } from "react-i18next";
import codigoCondutaImg from "../../imagens/Denuncia/codigoCondutaImg.png";
import codigoCondutaImgEn from "../../imagens/Denuncia/codigoCondutaImgEn.png";
import "./denunciaIntro.css";

const DenunciaIntro = () => {
  const { t, i18n } = useTranslation();

  // Verifica o idioma atual para o PDF
  const pdfLink =
    i18n.language === "en"
      ? "/pdfs/CodigoCondutaEn.pdf"
      : "/pdfs/CodigoConduta.pdf";

  // Verifica o idioma atual para a imagem
  const imgSrc = i18n.language === "en" ? codigoCondutaImgEn : codigoCondutaImg;

  return (
    <div className="container py-4">
      <div className="denuncia-intro-content">
        <div className="row align-items-center justify-content-center">
          <div className="col-12 col-md-5 text-center mb-4 mb-md-0">
            <img
              src={imgSrc}
              alt={t("denuncia.altImagem")}
              className="img-fluid"
            />
          </div>
          <div className="col-12 col-md-7 denuncia-texto-coluna">
            <div>
              <h4 className="mb-3 intro-text fw-bold">{t("denuncia.titulo")}</h4>
            </div>
            <p className="intro-text-content">{t("denuncia.paragrafo1")}</p>
            <p className="text-custom small intro-text-content">
              {t("denuncia.paragrafo2.parte1")}
              <a href={pdfLink} target="_blank" rel="noopener noreferrer">
                {t("denuncia.paragrafo2.link")}
              </a>
              {t("denuncia.paragrafo2.parte2")}
            </p>
            <p className="text-custom small">{t("denuncia.paragrafo3")}</p>
            <div className="text-custom mt-4 intro-garantias small">
              <p>
                <strong className="intro-Text">
                  {t("denuncia.garantias.confidencialidade.titulo")}
                </strong>{" "}
                {t("denuncia.garantias.confidencialidade.texto")}
              </p>
              <p>
                <strong className="intro-Text">
                  {t("denuncia.garantias.retaliacao.titulo")}
                </strong>{" "}
                {t("denuncia.garantias.retaliacao.texto")}
              </p>
              <p>
                <strong className="intro-Text">
                  {t("denuncia.garantias.integridade.titulo")}
                </strong>{" "}
                {t("denuncia.garantias.integridade.texto")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DenunciaIntro;
